export const EVENT_ACTIONS = {
  START: 'start',
  PLAYING: 'playing',
  PAUSED: 'paused',
  ENDED: 'ended'
};
//# sourceMappingURL=constants.js.map